import { customAlphabet } from 'nanoid'

const nanoid = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-', 21)
const DEVICE_ID_KEY = 'deviceId'
const SESSION_ID_KEY = 'sessionId'

/**
 * Returns a persistent device identifier.
 * Generates a UUID on first call and stores it in localStorage.
 * Subsequent calls return the same ID (same device across sessions).
 */
export const getDeviceId = (): string => {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY)
    if (!deviceId) {
        deviceId = crypto.randomUUID()
        localStorage.setItem(DEVICE_ID_KEY, deviceId)
    }
    return deviceId
}

/**
 * Returns a persistent session identifier for the current device.
 * Generates a nanoid on first call and stores it in localStorage.
 * Subsequent calls return the same ID so token re-exchanges reuse the session.
 */
export const getSessionId = (): string => {
    let sessionId = localStorage.getItem(SESSION_ID_KEY)
    if (!sessionId) {
        sessionId = nanoid()
        localStorage.setItem(SESSION_ID_KEY, sessionId)
    }
    return sessionId
}

/**
 * Clears a users session (tokens) from local storage and optionally removes the session ID.
 *
 * @param [tokensOnly=false] - If true, only removes access and refresh tokens.
 *                                       If false, also clears the session ID.
 */
export const clearSession = (tokensOnly = false): void => {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    if (!tokensOnly) {
        localStorage.removeItem(SESSION_ID_KEY)
    }
}
